/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    a: "a",
    pre: "pre",
    blockquote: "blockquote"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Can I use CSS frameworks?"
    }), "\n", _jsx(_components.p, {
      children: "Integrating an existing CSS framework with styled-components is really easy! You can use its existing class names alongside your components."
    }), "\n", _jsxs(_components.p, {
      children: ["For example, imagine you have an existing app with two classes you want to use again: ", _jsx(_components.code, {
        children: ".small"
      }), " and ", _jsx(_components.code, {
        children: ".big"
      }), ". If you want the class to always be attached to the component, you should use ", _jsxs(_components.a, {
        href: "/docs/api#attrs",
        children: ["the ", _jsx(_components.code, {
          children: "attrs"
        }), " method"]
      }), " to attach it. If you want to attach it only in some cases you can use the ", _jsx(_components.code, {
        children: "className"
      }), " props like you always have!"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "// Using .attrs, we attach the .small class to every <Button />\nconst Button = styled.button.attrs(props => ({\n  className: \"small\",\n}))`\n  background: black;\n  color: white;\n  cursor: pointer;\n  margin: 1em;\n  padding: 0.25em 1em;\n  border: 2px solid black;\n  border-radius: 3px;\n`;\n\nrender(\n  <div>\n    <Button>Styled Components</Button>\n    {/* Here we attach the class .big to this specific instance of the Button */}\n    <Button className=\"big\">The new way to style components!</Button>\n  </div>\n);\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["If the framework has a bunch of raw global CSS that needs to be included on the page, you can add it using the ", _jsxs(_components.a, {
        href: "/docs/api#createglobalstyle",
        children: [_jsx(_components.code, {
          children: "createGlobalStyle"
        }), " API"]
      }), ". This is also useful for things like CSS resets."]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["Note that for styled-components v3 and below, the previous API for global styles was ", _jsx(_components.a, {
          href: "/docs/api#injectglobal",
          children: _jsx(_components.code, {
            children: "injectGlobal"
          })
        }), "."]
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
